import React, { Component } from 'react';

class Center extends Component {
  render(){
    var p = this.props, s = this.state;
    var width = p.width || '50%';
    var height = p.height || 'auto';
    // var classText = p.classText || 'fake-class-name';
    // if(classText === "contact-center"){
    // }
    return (
      <div style={style.frame}>
        <div className={p.classText} style={{width: width, height: height, ...style.parent}}>
            {p.children}
        </div>
      </div>
    )
  }
}

export default Center;

var style = {
  frame: {
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  parent: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'table',
    margin: 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/Center.js